import React from 'react';
import { IProps } from './types';
import commonService from 'utils/commonService';
import { CodeId } from 'constants/enums/codeId.enum';
import SliderMobile from 'components/SliderMobile';

const Advantage: React.FC<IProps> = (props) => (
  <div className="advantage" ref={props.refSetting}>
    <div className="template-container">
      <div className="template-content">
        <div className="advantage__title-section">
          <div className="advantage__title">電子保單好處多</div>
        </div>
        <div className="advantage__items">
          <div className="advantage__item">
            <div className="advantage__item-content">
              <div className="advantage__item-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_T1)}</div>
              <p className="advantage__item-desc">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_B1)}</p>
            </div>
          </div>
          <div className="advantage__item">
            <div className="advantage__item-content">
              <div className="advantage__item-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_T2)}</div>
              <p className="advantage__item-desc">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_B2)}</p>
            </div>
          </div>
          <div className="advantage__item">
            <div className="advantage__item-content">
              <div className="advantage__item-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_T3)}</div>
              <p className="advantage__item-desc">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_B3)}</p>
            </div>
          </div>
          <div className="advantage__item">
            <div className="advantage__item-content">
              <div className="advantage__item-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_T4)}</div>
              <p className="advantage__item-desc">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_B4)}</p>
            </div>
          </div>
          <div className="advantage__item">
            <div className="advantage__item-content">
              <div className="advantage__item-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_T5)}</div>
              <p className="advantage__item-desc">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_B5)}</p>
            </div>
          </div>
        </div>
        <div className="advantage-mobile__items">
          <SliderMobile
            name="electronic-policy-advantage-slider"
          >
            <SliderMobile.Item>
              <div className="advantage__item">
                <div className="advantage__item-content">
                  <div className="advantage__item-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_T1)}</div>
                  <p className="advantage__item-desc">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_B1)}</p>
                </div>
              </div>
            </SliderMobile.Item>
            <SliderMobile.Item>
              <div className="advantage__item">
                <div className="advantage__item-content">
                  <div className="advantage__item-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_T2)}</div>
                  <p className="advantage__item-desc">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_B2)}</p>
                </div>
              </div>
            </SliderMobile.Item>
            <SliderMobile.Item>
              <div className="advantage__item">
                <div className="advantage__item-content">
                  <div className="advantage__item-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_T3)}</div>
                  <p className="advantage__item-desc">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_B3)}</p>
                </div>
              </div>
            </SliderMobile.Item>
            <SliderMobile.Item>
              <div className="advantage__item">
                <div className="advantage__item-content">
                  <div className="advantage__item-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_T4)}</div>
                  <p className="advantage__item-desc">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_B4)}</p>
                </div>
              </div>
            </SliderMobile.Item>
            <SliderMobile.Item>
              <div className="advantage__item">
                <div className="advantage__item-content">
                  <div className="advantage__item-title">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_T5)}</div>
                  <p className="advantage__item-desc">{commonService.getCodeMsg(props.ePolicyCodes, CodeId.BENEFIT_B5)}</p>
                </div>
              </div>
            </SliderMobile.Item>
          </SliderMobile>
        </div>
      </div>
    </div>
  </div>
);

export default Advantage;
